module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('div', {
    staticClass: "mine-box-title"
  }, [_vm._v(_vm._s(_vm.$T('我报名的赛事')))]), _vm._v(" "), _c('div', {
    staticClass: "mine-content"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$T('全部'),
      "name": "0"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$T('报名中'),
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$T('报名成功'),
      "name": "2"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.list,
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "用户名",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {}, [_vm._v(_vm._s(scope.row.saiqu_name))]), _vm._v(" "), _c('div', {
          staticClass: "gray-light"
        }), _vm._v(" "), _c('div', {
          staticClass: "goods-num gray-light"
        }, [_vm._v(_vm._s(_vm.$T('报名人数')) + " " + _vm._s(scope.row.membercount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "价格"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-goods-price"
        }, [_vm._v(_vm._s(scope.row.total_price || 0) + " "), _c('span', [_vm._v("USD")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "时间",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.create_time_str))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "用户名",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.memberStatusLabel(scope.row)) ? _c('el-tag', {
          attrs: {
            "type": _vm.memberStatusTagType(scope.row)
          }
        }, [_vm._v("\n              " + _vm._s(_vm.memberStatusLabel(scope.row)) + "\n            ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "min-width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.goDetail(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$T('报名详情')) + "\n            ")]), _vm._v(" "), (scope.row.show_upload_video) ? _c('el-button', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'ISaiApplyVideoList',
              query: {
                id: scope.row.id
              }
            }),
            expression: "{ name: 'ISaiApplyVideoList', query: { id: scope.row.id } }"
          }],
          attrs: {
            "size": "medium"
          }
        }, [_vm._v(_vm._s(_vm.$T('上传视频')) + "\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.have_cert) ? _c('el-button', {
          attrs: {
            "size": "medium"
          }
        }, [_vm._v(_vm._s(_vm.$T('下载证书')) + "\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.have_bu) ? _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.orderBu(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$T('补缴费用')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.beizhu(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$T('汇款信息')) + "\n            ")]), _vm._v(" "), (scope.row.memberstatus == 6) ? _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.successInfo(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$T('报名信息')) + "\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.memberstatus != 6) ? _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.onDelete(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$T('删除')) + "\n            ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": parseInt(_vm.row.currentpage),
      "page-size": _vm.params.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.row.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41d0d575","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyList.vue
// module id = 1427
// module chunks = 0